import { useForm } from "react-hook-form";
import Layout from "../../components/layouts/layout.comp";

import { useTranslation } from "../../core/translation.core";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { uploadProductFiles } from "../../core/productFile.core";
import { useRouter } from "next/router";

export default function ProductFile() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.product.productFileUpload)}>
      <Content />
    </Layout>
  );
}

function Content() {
  const methods = useForm<{ media: FileList }>();
  const queryClient = useQueryClient();
  const { t, msg } = useTranslation();
  const [uploadingStatus, setUploadingStatus] = useState<"init" | "uploading" | "uploaded">("init");
  const [error, setError] = useState<string | null>(null);
  const router = useRouter();

  function btnText() {
    switch (uploadingStatus) {
      case "init":
        return t(msg.media.uploadMediaFile);
      case "uploaded":
        return t(msg.form.uploaded);
      case "uploading":
        return t(msg.form.uploading);
    }
  }

  async function onSubmit(data: { media: FileList }) {
    try {
      setError(null);
      setUploadingStatus("uploading");

      if (!data.media || data.media.length === 0) {
        throw new Error("No files selected");
      }

      await uploadProductFiles(data.media, queryClient);

      router.push("/productFile");
    } catch (err) {
      console.error("Error uploading files:", err);
      setError(err instanceof Error ? err.message : "Failed to upload files");
      setUploadingStatus("init");
    }
  }

  return (
    <form
      id="mediaForm"
      onSubmit={methods.handleSubmit(onSubmit)}
      className="flex flex-col md:flex-row gap-8 justify-between w-full"
    >
      <div>
        <input type="file" className="" multiple {...methods.register("media")} />
        {error && <p className="text-red-500 mt-2">{error}</p>}
      </div>
      <div>
        <input
          type="submit"
          value={btnText()}
          className={`px-4 py-2 rounded ${
            uploadingStatus === "uploading" ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600 cursor-pointer"
          } text-white`}
          disabled={uploadingStatus === "uploading"}
        />
      </div>
    </form>
  );
}
